import React, { useState, useEffect, useRef } from 'react';
import AccountCommentCard from './AccountCommentCard';
import NewAccountCommentCard from './NewAccountCommentCard';
import {
    Row, Col,
    InputGroupText, Input, InputGroup, InputGroupAddon, FormGroup
} from 'reactstrap';
import { getAccountComments, saveAccountComment, addAccountComment, deleteAccountComment } from '../../API';

function Comments(props) {
    const [accountComments, setAccountComments] = useState([]);
    const [isLoadingComments, setIsLoadingComments] = useState(true);

    const [newComments, setNewComments] = useState([]);
    const [searchOptions, setSearchOptions] = useState(props.defaultSearch || {});
    const [searchTimeout, setSearchTimeout] = useState(false);
    const searchOptionsRef = useRef(searchOptions);
    const searchTimeoutRef = useRef(searchTimeout);
    searchOptionsRef.current = searchOptions;
    searchTimeoutRef.current = searchTimeout;

    useEffect(() => {
        const timeoutCommentSearch = async () => {
            setSearchTimeout(false);
            await search();
        };

        if (!searchTimeoutRef.current) {
            setSearchTimeout(true);
            setTimeout(timeoutCommentSearch, 500);
        }
    }, [searchOptions]);

    const search = async () => {
        setIsLoadingComments(true);

        const searchAPIResults = await getAccountComments(searchOptionsRef.current);
        setAccountComments(searchAPIResults.sort((a, b) => (a.commentDate < b.commentDate) ? 1 : ((b.commentDate < a.commentDate) ? -1 : 0)));

        setIsLoadingComments(false);
    };

    const getNewCommentId = () => {
        return newComments.map(u => u.accountCommentID).reduce((a, b) => (a > b) ? a : b, 0) + 1;
    };

    const addNewComment = () => {
        const tempId = getNewCommentId();
        const newComment = { accountCommentID: tempId, comment: '', accountId: props.accountId, commentDate: new Date() };
        setNewComments([newComment, ...newComments]);
    };

    const removeNewComment = (accountCommentId) => {
        const tempNewComments = [...newComments];
        const removeIndex = tempNewComments.findIndex(u => u.accountCommentID === accountCommentId);
        tempNewComments.splice(removeIndex, 1);
        setNewComments(tempNewComments);
    };

    const saveNewComment = async (newComment) => {
        const addableComment = {
            ...newComment,

        };
        delete addableComment.accountCommentID;

        const savedComment = await addAccountComment(addableComment);

        removeNewComment(newComment.accountCommentID);

        await search();
    };

    const saveComment = async (comment) => {
        await saveAccountComment(comment);

        await search();
    }

    const removeComment = async (accountCommentId) => {
        await deleteAccountComment(accountCommentId);

        await search();
    };

    const updateSearch = e => {
        setSearchOptions({
            ...searchOptions,
            [e.target.name]: e.target.value
        });
    };

    let accountCommentsJSX = (<div>No comments found.</div>);
    if (isLoadingComments)
        accountCommentsJSX = (<div>Loading...</div>);
    else if (accountComments.length > 0 || newComments.length > 0)
        accountCommentsJSX = (
            <div>
                {newComments?.map(u => (<NewAccountCommentCard key={u.accountCommentID} accountComment={u} cancel={removeNewComment} save={saveNewComment} />))}
                {accountComments?.map(u => (<AccountCommentCard key={u.accountCommentID} accountComment={u} delete={removeComment} save={saveComment} />))}
            </div>
        );

    return (
        <div>
            <Row xs={2} md={2} lg={3} xl={4} className="justify-content-between search-row">
                <Col>
                    <FormGroup>
                        <InputGroup className="tooltip-parent">
                            <InputGroupAddon addonType="prepend">
                                <InputGroupText><i className="fas fa-comment-dots"></i></InputGroupText>
                            </InputGroupAddon>
                            <Input type="text" name="comment" value={searchOptions.comment || ''} placeholder="Search Comments" onChange={updateSearch} />
                            <div className="tooltip-target">
                                Comment
                            </div>
                        </InputGroup>
                    </FormGroup>
                </Col>
                {window.env.user.userRoles.some(ur => [1, 2].includes(ur.roleID)) ? (
                    <Col>
                        <div onClick={addNewComment} className="action-icon action-add float-right tooltip-parent">
                            <i className="fas fa-plus"></i>
                            <div className="tooltip-target">
                                Add New Comment
                        </div>
                        </div>
                    </Col>
                ) : null}
            </Row>
            <Row>
                <Col>
                    {accountCommentsJSX}
                </Col>
            </Row>
        </div>
    );
}

export default Comments;